export default {
  title: 'Nebula buds AI Panggilan', // "Nebula buds AI通话" 翻译为马来语
  userID: 'ID Pengguna : ', // "用户ID : "
  hurryUp: 'Menunggu panggilan dari pihak lain', // "等待对方呼叫"
  waitingCall: 'Menunggu panggilan dari pihak lain di halaman ini, sila jangan tutup halaman lebih awal.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Suis Sarikata', // "字幕开关"
  initWait: 'Menunggu inisialisasi', // "等待初始化"
  initSuccess: 'Inisialisasi selesai, menunggu panggilan dari pihak lain. Sila jangan tutup halaman!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Panggilan disambungkan', // "电话接通"
  callEnd: 'Panggilan tamat', // "通话结束"
  careful: 'Perhatian : ', // "注意 : "
  wait: 'Komponen panggilan siap, menunggu panggilan dari pihak lain', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arab', // "阿拉伯语"
    da: 'Denmark', // "丹麦语"
    de: 'Jerman', // "德语"
    en: 'Inggeris', // "英语"
    es: 'Sepanyol', // "西班牙语"
    fil: 'Filipina', // "菲律宾语"
    fr: 'Perancis', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesia', // "印度尼西亚语"
    it: 'Itali', // "意大利语"
    ja: 'Jepun', // "日文"
    ko: 'Korea', // "韩语"
    ms: 'Melayu', // "马来语"
    no: 'Norway', // "挪威语"
    pt: 'Portugal', // "葡萄牙语"
    ru: 'Russia', // "俄语"
    sv: 'Sweden', // "瑞典语"
    th: 'Thailand', // "泰语"
    tr: 'Turki', // "土耳其语"
    vi: 'Vietnam', // "越南语"
    zh: 'Cina' // "中文"
  }
}
